module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sort-wrapper",
    on: {
      "click": function($event) {
        _vm.sortFun(2)
      }
    }
  }, [_vm._v("\n\t" + _vm._s(_vm.title) + "\n\t"), _c('span', {
    staticClass: "sort-content"
  }, [_c('i', {
    staticClass: "ascending",
    class: {
      'active': _vm.sortType == 0
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sortFun(0)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "descending",
    class: {
      'active': _vm.sortType == 1
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sortFun(1)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-305cce83!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sortTable.vue
// module id = 234
// module chunks = 2